import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthnProvider } from '@repo/auth';
import { useCreateOrganization } from '@repo/domains-organization';
import { organization_path } from '@repo/routes';
import { useCurrentUser } from '@repo/user-context';
import * as Sentry from '@sentry/react';
import { useNavigate } from '@tanstack/react-router';
import { createContext, useContext, useState } from 'react';
import { AddOrganizationModal } from './add-organization-modal';
import { AlphaAcceptModal } from './alpha-accept-modal';
const CreateOrgModalContext = /*#__PURE__*/ createContext(null);
export function useCreateOrgModal() {
    const context = useContext(CreateOrgModalContext);
    if (!context) {
        throw new Error('useCreateOrgModal must be used within CreateOrgModalProvider');
    }
    return context;
}
export function CreateOrgModalProvider(param) {
    let { children } = param;
    const { logout } = useAuthnProvider();
    const navigate = useNavigate();
    const [openAcceptModal, setOpenAcceptModal] = useState(false);
    const [openOrgCreateModal, setOpenOrgCreateModal] = useState(false);
    const { user } = useCurrentUser();
    const { mutateAsync: createOrganization } = useCreateOrganization();
    const openCreateOrgModal = ()=>{
        setOpenAcceptModal(true);
    };
    const onCreateOrgSave = async (organizationDisplayName, organizationName)=>{
        if (!user) {
            return;
        }
        if (!organizationName || !organizationDisplayName) {
            Sentry.captureMessage("Organization name or display name is empty: ".concat(organizationName, " ").concat(organizationDisplayName), {
                level: 'warning',
                user,
                tags: {
                    onCreateOrgSave: 'emptyName'
                }
            });
            return;
        }
        const _newOrg = {
            name: organizationName.trim(),
            displayName: organizationDisplayName.trim(),
            acceptedBy: user.id
        };
        const res = await createOrganization(_newOrg);
        if (res.data) {
            setOpenOrgCreateModal(false);
            setOpenAcceptModal(false);
            void navigate({
                to: organization_path({
                    organization: _newOrg
                }),
                search: (p)=>p,
                params: (p)=>p
            });
        }
    };
    const onAlphaAcceptModalConfirm = ()=>{
        setOpenAcceptModal(false);
        setOpenOrgCreateModal(true);
    };
    const dashboardNavigate = ()=>{
        setOpenAcceptModal(false);
        setOpenOrgCreateModal(false);
        void navigate({
            to: '/',
            search: (p)=>p,
            params: (p)=>p
        });
    };
    const handleOrgModalClose = ()=>{
        setOpenOrgCreateModal(false);
        setOpenAcceptModal(false);
    };
    return /*#__PURE__*/ _jsxs(CreateOrgModalContext.Provider, {
        value: {
            openCreateOrgModal
        },
        children: [
            children,
            /*#__PURE__*/ _jsx(AlphaAcceptModal, {
                open: openAcceptModal,
                onLogOut: ()=>void logout(),
                onChangeOrg: dashboardNavigate,
                onConfirm: onAlphaAcceptModalConfirm
            }),
            openOrgCreateModal && /*#__PURE__*/ _jsx(AddOrganizationModal, {
                open: openOrgCreateModal,
                onClose: handleOrgModalClose,
                onSave: (displayName, name)=>void onCreateOrgSave(displayName, name)
            })
        ]
    });
}
